import { IsNotEmpty, IsNumber, IsOneOfThese, IsValidDate } from '@core/services/csv/CSVCustomValidator'
import { CSVModelInterface } from '@core/services/csv/CSVModel.interface'
import { CommissionData } from '../../api'
import { Expose, Transform } from 'class-transformer'
import { parseFloatNumber, parseIntNumber } from '@core/services/csv/CSVTransformer'
import { isEmpty } from 'lodash'
import { ValidateIf } from 'class-validator'
import { DateService } from '@master/services/DateService'
import { FrequencyList, FrequencyToValueMapping, FrequencyType } from '@master/model/options/FrequencyOptions'
import { productTypes } from '@master/model/options/LineOfBusinessOptions'

const dateService = new DateService()

export class AvivaTransactionCsvModel extends CSVModelInterface implements CommissionData {
  @Expose()
  @IsNotEmpty()
  private 'Agent No' = '60006823 Agent Name'

  get advCode () {
    const agentNameAndCode = this['Agent No']
    const separator = agentNameAndCode.indexOf(' ')
    return separator > 0 ? agentNameAndCode.slice(0, separator) : ''
  }

  get advName () {
    const agentNameAndCode = this['Agent No']
    const separator = agentNameAndCode.indexOf(' ')
    return separator > 0 ? agentNameAndCode.slice(separator + 1) : ''
  }

  @Expose()
  @IsNotEmpty()
  private 'Policy Num' = 'Policy 123'

  get policyNumber () {
    return this['Policy Num']
  }

  @Expose()
  @IsNotEmpty()
  private 'Policy Holder' = 'John Doe'

  get clientName () {
    return this['Policy Holder']
  }

  @Expose()
  @IsNotEmpty()
  private 'Component' = 'Life Insurance Name'

  get productName () {
    const component = this.Component
    const separator = component.indexOf('-')
    return separator > 0 ? component.slice(0, separator) : ''
  }

  get componentCode () {
    const component = this.Component
    const separator = component.indexOf('-')
    return separator > 0 ? component.slice(separator + 1) : ''
  }

  @Expose()
  @IsNotEmpty()
  @IsOneOfThese(productTypes)
  private 'Product Type' = '[' + productTypes + ']'

  get productType () {
    return this['Product Type']
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.premiumPurpose))
  @IsOneOfThese(['SGD', 'CHF', 'EUR', 'GBP', 'USD', 'AUD', 'JPY', 'HKD'])
  private 'Cont Curr' = 'RP'

  get premiumPurpose () {
    return this['Cont Curr']
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'Extra Loading' = 123.45

  get loadingPremium () {
    return this['Extra Loading']
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'Premium Paid' = 123.45

  get premiumAmt () {
    return this['Premium Paid']
  }

  @Expose()
  @IsOneOfThese(FrequencyList.filter(frequency => !['RSP', 'Single'].includes(frequency)))
  private 'Bil Freq' = 'Monthly'

  get payMode () {
    return FrequencyToValueMapping(this['Bil Freq'] as FrequencyType)
  }

  @Expose()
  @Transform(({ value }) => parseIntNumber(value))
  @ValidateIf(o => !isEmpty(o.exchangeRate))
  @IsNumber()
  private 'FX Rate' = 1

  get exchangeRate () {
    return this['FX Rate']
  }

  @Expose()
  @Transform(({ value }) => parseIntNumber(value))
  @ValidateIf(o => !isEmpty(o.exchangeRate))
  @IsNumber()
  private 'Pol Term' = 1

  get policyTerm () {
    return this['Pol Term']
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.approvedDate))
  @IsValidDate('DD/MM/YYYY')
  private 'Inception Date' = '31/12/2020'

  get approvedDate (): number {
    return dateService.toUnixMilliseconds(this['Inception Date'], 'DD/MM/YYYY')
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.approvedDate))
  @IsValidDate('DD/MM/YYYY')
  private 'Paid To Date' = '31/12/2020'

  get paidToDate (): number {
    return dateService.toUnixMilliseconds(this['Paid To Date'], 'DD/MM/YYYY')
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  'Basic Comm' = 123.45

  get commissionAmt () {
    return this['Basic Comm']
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'Basic Overriding Comm' = 123.45

  get orCommissionAmt () {
    return this['Basic Overriding Comm']
  }

  @Expose()
  private 'Fee Type' = 'FYC-First'

  get descriptions () {
    return this['Fee Type']
  }
}
